/* istanbul ignore file */
import React from 'react';

import {
    canViewInstanceAnalytics,
    canViewPlatformAnalytics,
    isAnalyticsAllowed as isAnalyticsAllowedSelector,
} from '@lumapps/analytics/ducks/selectors';
import { isAskAIEnabled } from '@lumapps/ask-ai/ducks/selectors';
import { canAccessBroadcast } from '@lumapps/broadcasts/ducks/selectors';
import { isLearningEnabled } from '@lumapps/learning/ducks/selectors';
import { isInstanceSuperAdmin as isInstanceSuperAdminSelector, permissionsSelector } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { hasCoveoIndexingEnabled, isSearchAnalyticsEnabled } from '@lumapps/search-analytics/ducks/selectors';

import { AnalyticsSideNavigation as UI, AnalyticsSideNavigationProps } from './AnalyticsSideNavigation';

export const AnalyticsSideNavigation: React.FC<Pick<AnalyticsSideNavigationProps, 'id'>> = (props) => {
    const isInstanceSuperAdmin = useSelector(isInstanceSuperAdminSelector);
    const isAnalyticsReadAllowed = useSelector(isAnalyticsAllowedSelector);
    const isSearchAnalyticsFeatureEnabled = useSelector(isSearchAnalyticsEnabled);
    const hasCoveo = useSelector(hasCoveoIndexingEnabled);
    const canViewPlatformEntry = useSelector(canViewPlatformAnalytics);
    const canViewInstanceEntry = useSelector(canViewInstanceAnalytics);
    const isFFAskAiEnabled = useSelector(isAskAIEnabled);
    const permissions = useSelector(permissionsSelector);
    const learningEnabled = useSelector(isLearningEnabled);
    const hasBroadcastFF = useSelector(canAccessBroadcast);
    const hasBroadcastAccess = hasBroadcastFF && canViewPlatformEntry;

    const hasSearchAnalyticsAccess =
        (isInstanceSuperAdmin || (isAnalyticsReadAllowed && !hasCoveo)) && isSearchAnalyticsFeatureEnabled;
    const hasSiteAnalyticsAccess = canViewInstanceEntry;
    const hasExtendedAnalyticsAccess = canViewPlatformEntry;
    const hasMobileAnalyticsAccess = canViewPlatformEntry;
    const hasAskAiAccess = canViewPlatformEntry && isFFAskAiEnabled;
    const { canReadLearningAnalytics } = permissions.authorizations;
    const hasLearningAnalyticsAccess = canReadLearningAnalytics && learningEnabled;

    return (
        <UI
            {...props}
            hasSearchAnalyticsAccess={hasSearchAnalyticsAccess}
            hasSiteAnalyticsAccess={hasSiteAnalyticsAccess}
            hasExtendedAnalyticsAccess={hasExtendedAnalyticsAccess}
            hasMobileAnalyticsAccess={hasMobileAnalyticsAccess}
            hasLearningAnalyticsAccess={hasLearningAnalyticsAccess}
            hasAskAiAccess={hasAskAiAccess}
            hasBroadcastAccess={hasBroadcastAccess}
        />
    );
};
